
if (typeof __webpack_require__ !== "undefined") {
  var _ensureChunk = __webpack_require__.e;
  __webpack_require__.e = function (chunkId) {
    return Promise.resolve(_ensureChunk(chunkId)).catch(err => {
      const e = new Event("nuxt.preloadError");
      e.payload = err;
      window.dispatchEvent(e);
      throw err;
    });
  };
};